(function () {
  'use strict';

  // ─── State ────────────────────────────────────────────────────────────────
  let mapa = null;
  let markerCluster = null;
  let clusterObserver = null;  // MutationObserver para inyectar img en clusters
  let markers = [];
  let allPoints = [];        // todos los puntos cargados de Shopify
  let activeMarker = null;

  // ─── DOM refs ─────────────────────────────────────────────────────────────
  let mapsEl, panelEl, panelNameEl, panelAddressEl, panelIconEl, loaderEl;

  // ─── Config (desde data-* del div#maps) ──────────────────────────────────
  let shopDomain, storefrontToken, assetUrls, mapId;
  const STOREFRONT_API_VERSION = '2024-04';

  function init() {
    mapsEl = document.getElementById('maps');
    if (!mapsEl) return;

    shopDomain = mapsEl.dataset.shopDomain;
    storefrontToken = mapsEl.dataset.storefrontToken;
    mapId = mapsEl.dataset.mapId;
    assetUrls = {
      markerFavourite: mapsEl.dataset.markerFavourite,
      markerOptical: mapsEl.dataset.markerOptical,
      cluster2: mapsEl.dataset.cluster2,
      cluster3: mapsEl.dataset.cluster3,
      cluster4: mapsEl.dataset.cluster4,
      cluster5: mapsEl.dataset.cluster5,
    };

    panelEl = document.getElementById('storePanel');
    panelNameEl = document.getElementById('storePanelName');
    panelAddressEl = document.getElementById('storePanelAddress');
    panelIconEl = document.getElementById('storePanelIcon');
    loaderEl = document.getElementById('storeLoader');

    bindUI();
    showLoader(true);

    // Cargar datos y Google Maps en paralelo
    Promise.all([
      loadAllPoints(),
      new Promise(resolve => {
        const check = () => {
          if (typeof google !== 'undefined' && google.maps) resolve();
          else setTimeout(check, 100);
        };
        check();
      })
    ]).then(() => {
      startGoogleMaps();
      createAllMarkers();
      showLoader(false);
    });
  }

  // ─── Storefront API: cargar todos los map_point_json ─────────────────────
  async function loadAllPoints() {
    const url = `https://${shopDomain}/api/${STOREFRONT_API_VERSION}/graphql.json`;
    let cursor = null;
    let hasNextPage = true;

    while (hasNextPage) {
      const query = `{
        metaobjects(type: "map_point_json", first: 250${cursor ? `, after: "${cursor}"` : ''}) {
          pageInfo { hasNextPage endCursor }
          nodes {
            fields { key value }
          }
        }
      }`;

      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken,
        },
        body: JSON.stringify({ query }),
      });

      if (!res.ok) {
        console.error('[StoreLocator] Fetch error:', res.statusText);
        hasNextPage = false;
        break;
      }

      const data = await res.json();
      if (data.errors) {
        console.error('[StoreLocator] GraphQL errors:', data.errors);
        hasNextPage = false;
        break;
      }

      const result = data.data.metaobjects;
      if (!result) {
        hasNextPage = false;
        break;
      }

      result.nodes.forEach(function (node) {
        const pointField = node.fields.find(f => f.key === 'map_point');
        if (!pointField) return;
        try {
          const point = JSON.parse(pointField.value);
          if (Number.isFinite(point.lat) && Number.isFinite(point.lon)) {
            allPoints.push(point);
          }
        } catch (e) {
          console.warn('[StoreLocator] JSON inválido:', e);
        }
      });

      hasNextPage = result.pageInfo.hasNextPage;
      cursor = result.pageInfo.endCursor;
    }

    console.log(`[StoreLocator] ${allPoints.length} puntos cargados`);
  }

  // ─── Google Maps ──────────────────────────────────────────────────────────
  function startGoogleMaps() {
    const mapOptions = {
      zoom: 6,
      center: new google.maps.LatLng(40.416775, -3.703790), // Madrid
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      clickableIcons: false,
      gestureHandling: 'greedy', // Más fluido en mobile
    };

    if (mapId) mapOptions.mapId = mapId;

    mapa = new google.maps.Map(mapsEl, mapOptions);

    const input = document.getElementById('addressSF');
    if (input) {
      const searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener('places_changed', function () {
        const places = searchBox.getPlaces();
        if (!places || places.length === 0) return;
        const bounds = new google.maps.LatLngBounds();
        places.forEach(function (place) {
          if (!place.geometry) return;
          if (place.geometry.viewport) bounds.union(place.geometry.viewport);
          else bounds.extend(place.geometry.location);
        });
        mapa.fitBounds(bounds);
      });
    }

    mapa.addListener('zoom_changed', function () {
      if (mapa.getZoom() < 4) mapa.setZoom(4);
    });
  }

  // ─── Markers ──────────────────────────────────────────────────────────────
  function createAllMarkers() {
    if (!mapa || allPoints.length === 0) return;

    allPoints.forEach(function (point) {
      const marker = new google.maps.Marker({
        position: new google.maps.LatLng(point.lat, point.lon),
        icon: getMarkerIcon(),
      });

      marker._data = point;

      marker.addListener('click', function () {
        onMarkerClick(marker);
      });

      markers.push(marker);
    });

    initMarkerClusterer();
  }

  function initMarkerClusterer() {
    if (!mapa || markers.length === 0) return;

    markerCluster = new MarkerClusterer(mapa, markers, {
      styles: [
        { url: assetUrls.cluster2, height: 34, width: 34, anchorText: [11, 0], textColor: '#ffffff', textSize: 11 },
        { url: assetUrls.cluster3, height: 50, width: 50, anchorText: [19, 0], textColor: '#ffffff', textSize: 11 },
        { url: assetUrls.cluster4, width: 71,  height: 71, anchorText: [29, 0], textColor: '#ffffff', textSize: 11 },
        { url: assetUrls.cluster5, width: 96,  height: 96, anchorText: [41, 0], textColor: '#ffffff', textSize: 13 },
      ],
      maxZoom: 14,
      clusterClass: 'store-locator__map-cluster',
    });

    // Inyectar imagen real dentro de cada cluster (igual que la leyenda)
    var clusterSizes = [
      { maxW: 34,   src: assetUrls.cluster2, w: 34 },
      { maxW: 50,   src: assetUrls.cluster3, w: 50 },
      { maxW: 71,   src: assetUrls.cluster4, w: 71 },
      { maxW: 9999, src: assetUrls.cluster5, w: 96 },
    ];

    function injectClusterImg(el) {
      if (el.querySelector('.sl-cluster-bg')) return;
      var w = parseInt(el.style.width) || 34;
      var size = clusterSizes.find(function (s) { return w <= s.maxW; }) || clusterSizes[clusterSizes.length - 1];
      var img = document.createElement('img');
      img.src = size.src;
      img.className = 'sl-cluster-bg';
      img.alt = '';
      img.width = size.w;
      img.height = size.w;
      el.insertBefore(img, el.firstChild);
    }

    mapsEl.querySelectorAll('.store-locator__map-cluster').forEach(injectClusterImg);

    if (clusterObserver) clusterObserver.disconnect();
    clusterObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.classList.contains('store-locator__map-cluster')) {
            injectClusterImg(node);
          }
          node.querySelectorAll('.store-locator__map-cluster').forEach(injectClusterImg);
        });
      });
    });
    clusterObserver.observe(mapsEl, { childList: true, subtree: true });
  }

  function onMarkerClick(marker) {
    if (activeMarker && activeMarker !== marker) {
      activeMarker.setIcon(getMarkerIcon());
    }
    activeMarker = marker;
    renderPanel(marker._data);
    openPanel();
  }

  // ─── Panel ────────────────────────────────────────────────────────────────
  function setPanelAddressLines(el, lines) {
    while (el.firstChild) el.removeChild(el.firstChild);
    lines.forEach(function (line, index) {
      if (index > 0) el.appendChild(document.createElement('br'));
      el.appendChild(document.createTextNode(line));
    });
  }

  function renderPanel(point) {
    panelNameEl.textContent = point.CardName || '';
    const addressLines = [
      point.street,
      [point.zipCode, point.city].filter(Boolean).join(' '),
      point.country,
    ].filter(Boolean);
    setPanelAddressLines(panelAddressEl, addressLines);

    const img = document.createElement('img');
    img.src = assetUrls.markerOptical;
    img.width = 24;
    img.height = 32;
    img.alt = '';
    while (panelIconEl.firstChild) panelIconEl.removeChild(panelIconEl.firstChild);
    panelIconEl.appendChild(img);
  }

  function openPanel() {
    panelEl.classList.add('is-open');
    panelEl.setAttribute('aria-hidden', 'false');
  }

  function closePanel() {
    panelEl.classList.remove('is-open');
    panelEl.setAttribute('aria-hidden', 'true');
    activeMarker = null;
  }

  // ─── UI helpers ───────────────────────────────────────────────────────────
  function bindUI() {
    const closeBtn = document.getElementById('storePanelClose');
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    const geoBtn = document.querySelector('.store-locator__geolocation');
    if (geoBtn) {
      geoBtn.addEventListener('click', function () {
        if (!navigator.geolocation || !mapa || typeof google === 'undefined' || !google.maps) return;
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            if (!mapa) return;
            mapa.setCenter(new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude));
            mapa.setZoom(15);
          },
          function (err) { console.warn('[StoreLocator] Geolocation error:', err); },
          { enableHighAccuracy: true, timeout: 4000, maximumAge: 0 }
        );
      });
    }
  }

  function showLoader(visible) {
    if (!loaderEl) return;
    loaderEl.classList.toggle('is-visible', visible);
    loaderEl.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function getMarkerIcon() {
    return {
      url: assetUrls.markerOptical,
      scaledSize: new google.maps.Size(24, 32),
      anchor: new google.maps.Point(12, 32),
    };
  }

  // ─── Boot ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
